import { useState } from "react";
import { StorageService } from "../../services/storage";
import { useNavigate } from "react-router-dom";
import { STORAGE } from "../../constants";

function Header() {
  const navigate = useNavigate();

  const [session, setSession] = useState(StorageService.get(STORAGE.USER))
  
  const logout = () => {
    StorageService.clear();
    navigate('/auth/login');
  }

  return (
    <div
      className="header"
      data-kt-sticky="true"
      data-kt-sticky-name="header"
      data-kt-sticky-offset="{default: '200px', lg: '300px'}"
      id="kt_header"
    >
      <div className="container-fluid d-flex align-items-stretch justify-content-between">
       
        <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
          <div className="d-flex align-items-stretch me-1">
            <div
              className="header-search d-flex align-items-center w-100 w-lg-300px"
              data-kt-menu-permanent="true"
              data-kt-menu-placement="bottom-start"
              data-kt-menu-trigger="auto"
              data-kt-search-enter="enter"
              data-kt-search-keypress="true"
              data-kt-search-layout="menu"
              data-kt-search-min-length="2"
              data-kt-search-responsive="lg"
              id="kt_header_search"
            >
              <div
                className="search-toggle-mobile d-flex d-lg-none align-items-center"
                data-kt-search-element="toggle"
              >
                <div className="d-flex">
                  <i className="ki-duotone ki-magnifier fs-1">
                    <span className="path1" />
                    <span className="path2" />
                  </i>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-stretch flex-shrink-0">
           

            <div
              className="d-flex align-items-center ms-2 ms-lg-3"
              id="kt_header_user_menu_toggle"
            >
              <div
                className="cursor-pointer symbol symbol-35px symbol-lg-35px"
                data-kt-menu-attach="parent"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
              >
                <img alt="Pic" src="/assets/media/avatars/300-1.jpg" />
              </div>
              <div
                className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px"
                data-kt-menu="true"
              >
                <div className="menu-item px-3">
                  <div className="menu-content d-flex align-items-center px-3">
                    <div className="symbol symbol-50px me-5">
                      <img alt="Logo" src="/assets/media/avatars/300-1.jpg" />
                    </div>
                    <div className="d-flex flex-column">
                      <div className="fw-bold d-flex align-items-center fs-5">
                      {session?.name}
                      </div>
                      <a
                        className="fw-semibold text-muted text-hover-primary fs-7"
                        href="#"
                      >
                        {session?.email}
                      </a>
                    </div>
                  </div>
                </div>
                <div className="separator my-2" />
                
               
                <div className="menu-item px-5">
                  <a
                    className="menu-link px-5"
                    onClick={logout}
                  >
                    Cerrar sesión
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
